import { Injectable } from '@angular/core';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class SaleCommandsService {

  constructor(private commonService: CommonService) { }

  async fetchSaleCommand(recordId: number) {
    return await this.commonService.getSimpleList(`sale_command/${recordId}`);
  }

  async insertSaleCommand(model: any) {
    return await this.commonService.insertObject(`sale_command`, model);
  }

  async completeSaleCommand(recordId: number) {
    return await this.commonService.updateObject(`sale_command/complete/${recordId}`, {});
  }

  async assignSaleCommand(data) {
    return await this.commonService.updateObject(`sale_command/routing`, data);
  }

  async fetchUsersForAssign() {
    return await this.commonService.getSimpleList(`sale_command/users`);
  }
}
